<app-header></app-header>

<div class="row h100 exhibitor-backoffice">
  <div class="col-12 col-lg-2 h100 exhibitor-backoffice__left">
    <app-menu-exhibitor [active]="'util-info'"></app-menu-exhibitor>
  </div>
  <div class="col-12 col-lg-10 exhibitor-backoffice__right">

    <div class="row pd-t50 exhibitor-backoffice-sub-header" [style.background-color]="catalogueService.getProperty('mainColor')" [style.color]="catalogueService.getProperty('languageColor')">
      <div class="col-lg-9">
        <h1>{{ 'EXHIBITOR_BACKOFFICE_UTIL_INFO.TITLE' | translate }}</h1>
      </div>
    </div>

    <div class="exhibitor-backoffice__content">

      <h2>{{ 'EXHIBITOR_BACKOFFICE_UTIL_INFO.INFO' | translate }}</h2>
      <div class="welcome-info" [innerHTML]="utilsService._api(welcomePackTranslations, 'message')"></div>

      <div class="welcome-boxes" *ngIf="welcomeBoxes.length > 0">
        <div class="welcome-boxes__box" [ngClass]="{ 'welcome-boxes__box--linkable': getUrl(box.translations) }" (click)="goTo(box.translations)"
          *ngFor="let box of welcomeBoxes" [style.background-color]="box.colorBackground" [style.color]="box.colorText">
          <div class="welcome-boxes__box-title">{{ utilsService._api(box.translations, 'title') }}</div>
          <div class="welcome-boxes__box-description" [innerHTML]="utilsService._api(box.translations, 'message')"></div>
        </div>
      </div>

      <h2 *ngIf="welcomeFiles.length > 0">{{ 'EXHIBITOR_BACKOFFICE_UTIL_INFO.DOWNLOADS' | translate }}</h2>
      <div class="welcome-files" *ngIf="welcomeFiles.length > 0">
        <ng-container *ngFor="let file of welcomeFiles">
          <a [href]="file.url" target="_blank" class="detail-content__file-item d-flex align-items-center">
            <img _ngcontent-c6="" class="pointer" height="36" src="assets/img/document-big.svg" width="36" alt="file">
            <span class="ml-2 file">{{ file.name }}</span>
            <img class="pointer ml-auto" width="24" height="24" [alt]="'CARD_DETAIL.DOWNLOAD' | translate" src="assets/img/download.svg">
          </a>
        </ng-container>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>
